import React from "react";

const Policy = () => {
  return (
    <section className="min-h-screen pb-10 bg-white px-6 md:px-20 py-10">
      
      {/* Heading */}
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">
        Privacy Policy
      </h1>

      {/* Intro */}
      <p className="text-gray-600 mb-6">
        At Sunrising Cinevision , we are committed to protecting your
        privacy and ensuring that your personal information is handled in a safe
        and responsible manner. This policy outlines how we collect, use, and
        protect your information.
      </p>

      {/* Section 1 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <p className="text-gray-600 mb-4">
        We may collect personal details such as your name, phone number, email
        address, and other information when you contact us, enroll in our
        courses, or interact with our services.
      </p>

      {/* Section 2 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <p className="text-gray-600 mb-4">
        The information we collect is used to provide better services, improve
        our courses, communicate important updates, and respond to your queries.
      </p>

      {/* Section 3 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Data Protection
      </h2>
      <p className="text-gray-600 mb-4">
        We take appropriate security measures to protect your personal data from
        unauthorized access, misuse, or disclosure.
      </p>

      {/* Section 4 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Sharing of Information
      </h2>
      <p className="text-gray-600 mb-4">
        We do not sell or share your personal information with third parties,
        except when required by law or necessary to provide our services.
      </p>

      {/* Section 5 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Cookies & Tracking
      </h2>
      <p className="text-gray-600 mb-4">
        Our website may use cookies to enhance user experience and analyze
        website traffic. You can control cookie settings through your browser.
      </p>

      {/* Section 6 */}
      {/* <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Contact Information
      </h2>
      <p className="text-gray-600 mb-2">
        If you have any questions regarding this policy, feel free to contact us:
      </p> */}

      {/* <ul className="text-gray-600">
        <li>📞 +91 9983333191</li>
        <li>📧 info@sunrisingcinevisionacademy.in</li>
        <li>
          📍 Shop No. B - LGF - 14, R-Tech Capital High Street Mall, Jagatpura,
          Jaipur
        </li>
      </ul> */}

    </section>
  );
};

export default Policy;